/* Zenia scroll motion. Safe by design: if anything here fails, the page simply shows as normal. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = window.Shopify && window.Shopify.designMode;
  if (reduce || inEditor) return;

  var root = document.documentElement;
  var hasIO = 'IntersectionObserver' in window;

  // ----- 1. Fade and slide in -----
  var REVEAL_SELECTOR = [
    '.section-heading',
    '.home-about__card',
    '.home-overview__sidebar',
    '.home-overview__content',
    '.home-product-list__row',
    '.home-brands__group',
    '.home-contact__heading',
    '.home-contact__group',
    '.home-contact__list > li',
    '.ai-catalogue-wrap [data-catalogue-card]',
    '[data-catalogue-card]',
    '.article-card-wrapper',
    '.blog-articles__article',
    '.home-marquee',
    '.journey__item'
  ].join(',');

  function setupReveal() {
    if (!hasIO) return;
    var items = Array.prototype.slice.call(document.querySelectorAll(REVEAL_SELECTOR));
    if (!items.length) return;

    root.classList.add('zm-js');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        el.classList.add('zm-in');
        // Hand the element back to its normal styles once it has arrived (keeps hover effects working).
        setTimeout(function () {
          el.classList.remove('zm-reveal', 'zm-in');
          el.style.removeProperty('--zm-d');
        }, 1600);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    items.forEach(function (el) {
      var parent = el.parentElement;
      var index = parent ? Array.prototype.indexOf.call(parent.children, el) : 0;
      el.style.setProperty('--zm-d', String(Math.min(Math.max(index, 0), 6)));
      el.classList.add('zm-reveal');
      io.observe(el);
    });
  }

  // ----- 3. Slim header on scroll, 5. banner drift, 8. progress line (one shared scroll loop) -----
  var progress = document.createElement('div');
  progress.className = 'zm-progress';
  progress.setAttribute('aria-hidden', 'true');

  var ticking = false;
  function update() {
    ticking = false;
    var y = window.pageYOffset || root.scrollTop || 0;

    if (y > 24) root.classList.add('zm-scrolled');
    else root.classList.remove('zm-scrolled');

    var max = (root.scrollHeight - window.innerHeight) || 1;
    progress.style.transform = 'scaleX(' + Math.min(Math.max(y / max, 0), 1) + ')';

    var hero = document.querySelector('.video-hero');
    if (hero) {
      var h = hero.offsetHeight || 1;
      var shift = Math.min(y * 0.18, h * 0.08);
      root.style.setProperty('--zm-par', shift.toFixed(1) + 'px');
    }
  }
  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  // ----- 6. Counters (category numbers, and the number in "Serving 3 countries") -----
  function animateCount(el, target, suffix) {
    var duration = 1400;
    var start = performance.now();
    function tick(now) {
      var p = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(target * eased)) + (suffix || '');
      if (p < 1) window.requestAnimationFrame(tick);
      else el.textContent = String(target) + (suffix || '');
    }
    window.requestAnimationFrame(tick);
  }

  function setupCounters() {
    if (!hasIO) return;
    var targets = [];

    // Category numbers in the "What we offer" list
    var counts = document.querySelectorAll('.home-overview__item-count');
    var sidebar = document.querySelector('.home-overview__sidebar');
    if (sidebar && counts.length) {
      var values = Array.prototype.map.call(counts, function (c) { return parseInt(c.textContent, 10); });
      var ioSide = new IntersectionObserver(function (entries) {
        var seen = entries.some(function (e) { return e.isIntersecting; });
        var passed = entries.some(function (e) { return e.boundingClientRect.bottom < 0; });
        if (!seen && !passed) return;
        ioSide.disconnect();
        Array.prototype.forEach.call(counts, function (c, i) {
          if (isNaN(values[i])) return;
          if (seen) animateCount(c, values[i]);
          else c.textContent = String(values[i]);
        });
      }, { threshold: 0.3 });
      Array.prototype.forEach.call(counts, function (c, i) { if (!isNaN(values[i])) c.textContent = '0'; });
      ioSide.observe(sidebar);
    }

    // A number inside a point title, such as "Serving 3 countries"
    document.querySelectorAll('.home-about__point-title').forEach(function (title) {
      var m = title.textContent.match(/^(.*?)(\d+)(.*)$/);
      if (!m) return;
      var n = parseInt(m[2], 10);
      if (isNaN(n) || n > 1000) return;
      title.textContent = '';
      title.appendChild(document.createTextNode(m[1]));
      var num = document.createElement('span');
      num.textContent = '0';
      title.appendChild(num);
      title.appendChild(document.createTextNode(m[3]));
      var ioNum = new IntersectionObserver(function (entries) {
        var seen = entries.some(function (e) { return e.isIntersecting; });
        var passed = entries.some(function (e) { return e.boundingClientRect.bottom < 0; });
        if (!seen && !passed) return;
        ioNum.disconnect();
        if (seen) animateCount(num, n);
        else num.textContent = String(n);
      }, { threshold: 0.6 });
      ioNum.observe(title);
    });
  }

  function init() {
    try { setupReveal(); } catch (e) {}
    try { setupCounters(); } catch (e) {}
    document.body.appendChild(progress);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
